const data = [{
    id: 1,
    imagePath: "images/img_alpes.jpg",
    description: "Parapente dans les Alpes",
    done: true,
    link: "https://www.absolute-chamonix.com/bapteme-parapente?gclid=CjwKCAiAgeeqBhBAEiwAoDDhn8NHqd7GzR5e2NQJz8aoR-8ZLiiNiUtr2A4YKR6Ky0oH_PGDGkOo5RoCWoYQAvD_BwE",
    coordinates: {
        lat: 45.92428494010356,
        lng: 6.86971028281086
    }
},

    {
        id: 2,
        imagePath: "images/img_ireland.jpg",
        description: "Tour de l'Irlande",
        done: false,
        link: "https://www.evaneos.fr/irlande/itineraire/8095-grand-tour-a-la-decouverte-des-plus-beaux-sites-irlandais/",
        coordinates: {
            lat: 53.000838322876234,
            lng: -6.372821493840465
        }
    },


    {
        id: 3,
        imagePath: "images/img_japon.jpg",
        description: "Découvrir le Japon",
        done: false,
        link: "https://www.maisonsduvoyage.com/asie/japon",
        coordinates: {
            lat: 35.451788982862006,
            lng: 139.6313074666276
        }
    },


    {
        id: 4,
        imagePath: "images/img_koala.jpg",
        description: "Parler avec les animaux",
        done: false,
        link: "https://www.petitfute.com/v43700-mount-isa/",
        coordinates: {
            lat: -20.72451480,
            lng: 139.49472000
        }
    },
    {
        id: 5,
        imagePath: "images/img_santa.jpg",
        description: "découvrir les rennes du père noël",
        done: false,
        link: "https://santaclausvillage.info/fr/",
        coordinates: {
            lat: 66.54355886071782,
            lng: 25.84795904576637
        }
    },


    {
        id: 6,
        imagePath: "images/img_ggg.jpg",
        description: "GGG !!! :-) ",
        done: true,
        link: "https://www.mariegalante360.com/visiter-l-ile/sites-touristiques/gueule-grand-gouffre/",
        coordinates: {
            lat: 16.253375105137327,
            lng: -61.2666595388933
        }
    },




    {
        id: 7,
        imagePath: "images/distillerie-bellevue.jpg",
        description: "Marie-Galante",
        done: true,
        link: "https://fdmf.fr/marie-galante-lile-aux-cent-moulins-guadeloupe/",
        coordinates: {
            lat: 15.926593610044295,
            lng: -61.24172124484173
        }
    },

    {
        id: 8,
        imagePath: "images/img_noumea.jpg",
        description: "Voir le coucher de soleil à Nouméa",
        done: false,
        link: "https://www.noumea.nc/",
        coordinates: {
            lat: -22.28618251782442,
            lng: 166.45679486180927
        }
    },








]



export {data} ;





//////////////////
// WEBPACK FOOTER
// ./src/data.js
// module id = 3
// module chunks = 0